import { render, staticRenderFns } from "./LoginHuhuIcon.vue?vue&type=template&id=4db4bdff&"
import script from "./LoginHuhuIcon.vue?vue&type=script&lang=js&"
export * from "./LoginHuhuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports